export const phrases = {
  heading_settings_sort: "Сортиране на списъка с персонала",
  body_settings_sort: "Сортирайте списъка с персонала по име или фамилия.",
  since_o_clock: "Тъй като {time} часовник",
  old_data_warning_my_area: "Не успяхме да заредим нова информация. Уверете се, че сте свързани с интернет.",
  no_data_warning_my_area: "Уверете се, че сте свързани с интернет, и опитайте отново.",
  no_data_available_my_area: "Не могат да бъдат заредени данни",
  last_update_data: "Последна актуализация",
  something_went_wrong_absences: "Нещо се е объркало. Моля, опитайте отново на по-късна дата.",
  something_went_wrong_with_the_pin_entry: "Нещо се е объркало при въвеждането на ПИН кода...",
  pin_must_be_four_digits: "ПИН кодът трябва да се състои от точно четири цифри.",
  pins_do_not_match: "Въведените ПИН кодове не съвпадат.",
  pin_is_not_numerical: "ПИН кодът може да се състои само от цифри.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Подпечатайте се",
  finish_break: "Край на почивката",
  finish_loading_time: "Време за зареждане на края",
  finish_driving_time: "Край на времето за шофиране",
  finish_business_trip: "Приключване на служебното пътуване",
  finish_project_as_task: "Завършване на проекта",
  finish_special_one: "Край на special1",
  finish_special_two: "Край на Special2",
  you_clockout: "Отпечатваш се",
  sentence_work_time: "Работите. | Вие работите точно сега.",
  sentence_break: "Вземате си почивка. | Взимате си почивка.",
  sentence_loading_time: "В момента записвате времето за зареждане. Hauruck! | В момента записвате време за зареждане. Джърк!",
  sentence_business_trip: "Службата е влязла в системата. Забавлявайте се!",
  sentence_driving_time: "Резервирате време за шофиране. Закопчайте коланите и тръгвайте! | Резервирате време за пътуване. Закопчайте коланите и тръгвайте!",
  sentence_special_one: "Резервирате Special 1. | Резервирате специален 1.",
  sentence_special_two: "Резервирате Special 2. | Резервирате специален пакет 2.",
  sentence_custom_time: "Вие правите резервация | Вие правите резервация",
  you_are_booked_in_activity: "Печат {activity}! | Печат {activity}!",
  substitute_warning: "{ days } При отсъствие от един или повече дни трябва да се посочи заместник.",
  substituted_by: "Представлявано от",
  name_clocked_in: "{name} щампован",
  /************************************/
  //Signature stuff:

  signature: "Подпис",
  please_sign: "Моля, подпишете",
  signature_with_date: "Подпис от {date}",
  signature_with_date_with_name: "Подпис на {date} от {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Подпис на {date} от {name} в {location}",
  signature_with_name: "Подпис на {name}",
  signature_with_name_with_location: "Подпис на {name} в {location}",
  signature_with_location: "Подпис в {location}",
  /*************************************/

  accept_terms_and_conditions: "Изпращайки формуляра, вие приемате нашия {agb} и нашия {datenschutzerklaerung}.",
  what_is_your_name: "Как се казвате?",
  your_email: "Вашият имейл адрес",
  what_is_your_company_name: "Какво е името на вашата компания?",
  what_do_you_want_to_do_with_clockin: "Какво искате да направите с часовника?",
  almost_finished: "Почти готово",
  test_clockin_for_amount_period: "Тествайте clockin {amountOfDaysTestPeriod} безплатно в продължение на няколко дни!",
  code_needed_to_connect: "Използвайте своя код",
  you_have_no_company_code: "Нямате код? Свържете се с лицето във вашата компания.",
  connect_your_device: "Свържете устройството си!",
  please_type_in_device_id: "Моля, въведете идентификатора на устройството, който можете да намерите в раздела за мобилни устройства на нашия уебсайт.",
  new_at_clockin: "Нов потребител на часовника?",
  pin_repeat: "Повтаряне на ПИН",
  configure_your_pin: "Задайте 4-цифрения си ПИН код",
  configure_your_pin_text: "ПИН кодът е необходим за достъп до личната ви зона на таблетния терминал.",
  congratulations: "Поздравления!",
  start_now: "Започнете сега",
  device_name_info: "Можете да промените името на устройството на мобилното си устройство, за да можете да следите няколко устройства. Пример: \"Смартфон MaxMustermann\". Името може да бъде променено и на по-късна дата.",
  select_project: "Изберете проект",
  select_time: "Време за избор",
  create_new_account: "Създаване на нов акаунт",
  join_my_company: "Присъедини се към моята компания",
  join_clockin_with_qr: "Присъединете се с QR код",
  change_project: "Проект за промяна",
  my_messages: "Моите новини",
  my_documents: "Моите документи",
  my_data_and_passwords: "Моите данни и пароли",
  my_account_data: "Моите данни",
  change_my_password: "Промяна на паролата",
  forgot_password: "Не знам паролата си.",
  open_camera: "Отворена камера",
  scan_now: "Сканиране сега",
  sync_now: "Синхронизиране сега",
  clear_logs: "Празни дневници",
  saveAndGoBack: "Запазване и връщане",
  full_day: "Пълен ден",
  activate_scanner: "Скенерът е активиран",
  scanner_is_inactive: "Неактивен скенер",
  change_project_by_scan_qr: "Сканирайте QR кода на проекта, към който искате да преминете.",
  scan_device_by_qr: "Сканирайте QR кода от устройството, което искате да използвате.",
  no_access_to_camera_please_connect_device_manually: "За съжаление достъпът до камерата не е възможен, моля, въведете кода на устройството ръчно.",
  no_access_to_camera_please_clockin_manually: "За съжаление, не беше възможен достъп до камерата, моля, отпечатайте ръчно.",
  qr_code_login: "Регистрация на QR код",
  scan_to_login: "Сканирайте своя QR код, за да влезете в системата.",
  checklist_was_saved: "Контролният списък е запазен",
  question_save_changes_short: "Запазване на промените?",
  question_save_changes: "Искате ли да запазите промените?",
  question_delete_checklist_short: "Изтриване на контролния списък?",
  question_delete_checklist: "Сигурни ли сте, че искате да изтриете контролния списък?",
  checklist_is_sending: "Контролният списък ще бъде изпратен",
  checklist_sent_successfully: "Контролният списък е изпратен успешно 🎉",
  checklist_could_not_be_sent: "Контролният списък не може да бъде изпратен, моля, опитайте отново по-късно.",
  checklist_transmission_problems_in_the_past: "В миналото имаше проблеми с прехвърлянето на някои файлове.",
  checklist_send_with_potential_data_loss: "Искате ли да опитате да изпратите контролния списък без тези файлове?",
  documentation_is_sending: "Изпраща се проектната документация",
  documentation_sent_successfully: "Проектната документация е изпратена успешно 🎉",
  confirm_documentation_dismissal: "Наистина ли искате да изхвърлите документацията?",
  discard_unsaved_changes: "Искате ли да се откажете от промените си?",
  documentation_will_be_sent_when_online: "Документацията ще бъде изпратена веднага след като отново сте онлайн.",
  confirmation_is_sending: "Изпратено е потвърждение на проекта",
  ask_for_geo_permission: "Това приложение се нуждае от вашето местоположение, " + "но не разполага с разрешение за това.\n\n" + "Искате ли да отворите настройките?",
  all_projects: "Всички проекти",
  half_day: "Половин ден",
  start_end: "В зависимост от времето",
  my_area: "Моята област",
  my_area_video_teaser_clockin_explained_by_frederik: "часовникът обяснен от Фреди",
  add_time: "Създаване на време",
  show_times_in_confirmation: "Часове на показване в потвърждение",
  change_time: "Време за промяна",
  finish_project: "Завършване на проекта",
  finish_project_date: "Финализиране на назначението",
  unfinish_project: "Повторно отваряне на проекта",
  unfinish_project_date: "Повторно откриване на среща",
  absence_overview: "Управление на отсъствията",
  edit_absence: "Редактиране на липсата",
  edited_absence: "Редактирано отсъствие",
  created_absence: "Успешно създадена заявка за отпуск",
  creating_absence: "Вашата молба за отпуск вече е създадена.",
  error_creating_absence: "Грешка при създаването на заявката за отсъствие",
  create_absence: "Създаване на отсъствие",
  deleted_absence: "Оттегляне на молбата за отсъствие",
  new_request: "Ново приложение",
  your_requests: "Вашите приложения",
  planned_days: "Планирани дни",
  planned_hours: "Планирано работно време",
  used_days: "Използвани дни",
  used_hours: "Прекарани часове",
  free_days: "Почивни дни",
  free_hours: "Ваканционно време",
  open_days: "Дни на отворените врати",
  open_hours: "Работно време",
  withdraw_request: "Оттегляне на заявлението",
  change_request: "Искане за промяна",
  request_was_approved: "Заявката ви е одобрена",
  request_is_pending: "Заявката ви все още не е одобрена",
  request_was_rejected: "Заявката ви е отхвърлена",
  add_attachment: "Добавяне на прикачен файл",
  message_optional: "Съобщение (по избор)",
  filed_on: "Подаден на",
  this_year: "Тази година",
  search_sub_projects: "По кой подпроект искате да работите?",
  error_occurred: "Възникна грешка, опитайте отново по-късно.",
  re_record: "Да изтрия и презапиша това видео?",
  delete_video: "Да изтрия записа?",
  no_results_found: "Не са намерени резултати",
  record_again: "Опитайте",
  request_valid_email: "Моля, въведете валиден имейл адрес.",
  request_valid_company_name: "Моля, въведете валидно име на компанията.",
  request_valid_first_name: "Моля, въведете валидно първо име.",
  request_valid_last_name: "Моля, въведете валидно фамилно име.",
  total_duration_today: "Общо време днес",
  show_daily_protocol: "Показване на ежедневния дневник",
  change_profile_pic: "Промяна на профилната снимка",
  logout_account: "Прекъсване на връзката с акаунта",
  you_are_working: "Работите точно сега!",
  you_are_taking_a_break: "Имате почивка!",
  activity_edited: "Редактирана дейност",
  activity_edited_undo: "Обработката е успешно отменена",
  activity_edited_missing_project: "О, проектът все още липсва!",
  activity_deleted: "Изтрита дейност",
  activity_deleted_undo: "Възстановяване на изтрита дейност",
  activity_created: "Създаване на нова дейност",
  activity_created_undo: "Оттегляне на новосъздадена дейност",
  correct_working_hours: "Правилно работно време",
  your_changes_are_being_saved: "Промените са запазени.",
  manage_working_hours: "Управление на работното време",
  delete_activity: "Изтриване на дейността",
  start_navigation: "Начало на навигацията",
  no_valid_email: "Въведеният имейл адрес не е валиден.",
  delete_checklist: "Изтриване на контролния списък",
  active_checklists: "Активни контролни списъци",
  scan_qr_code: "Сканиране на QR код",
  switch_to_office_center: "Преминаване към офисния център",
  confirm_project_completion_short: "Завършване на проекта",
  confirm_project_date_completion_short: "Финализиране на назначението",
  project_completed: "Проектът е завършен!",
  project_date_completed: "Назначението е финализирано!",
  confirm_project_uncompletion_short: "Повторно отваряне на проекта",
  confirm_project_date_uncompletion_short: "Повторно откриване на среща",
  project_uncompleted: "Активиран проект",
  project_date_uncompleted: "Дата на активиране",
  choose_project: "Изберете проект",
  choose_sub_project: "Избор на подпроект",
  choose_site: "Изберете местоположение",
  active_projects: "Активни проекти",
  completed_term: "завършен",
  completed_projects: "Завършени проекти",
  end_of_work: "Приятна вечер",
  correct_time: "Правилно време",
  you_stamp_x: "Печатате",
  enter_pin: "Моля, въведете ПИН",
  wrong_pin: "Неправилно въвеждане на ПИН",
  pin_change_required: "Получихте покана за промяна на ПИН кода.",
  enter_new_pin: "Въвеждане на нов ПИН код",
  approve_pin: "Потвърждаване на ПИН",
  no_projects_scheduled: "За {day} Не се съхраняват проекти.",
  you_clock_in_project: "Отсега нататък записвате работното време на проекта.",
  project_scan_error: "Този код не е валиден за нито един проект.",
  show_more_days: "Покажи повече дни",
  show_more_times: "Покажи повече пъти",
  only_show_today: "Покажете само днес",
  todays_total_time: "Общо време днес",
  everything_synced: "Вашите данни са актуални!",
  upload_in_progress: "Данните се качват...",
  who_are_you: "Кой си ти?",
  is_uploading_to_server: "Вашите промени се прехвърлят в офисния център.",
  offline_and_data_is_stored_locally: "Скоро промените ще бъдат прехвърлени в офисния център. ",
  show_more: "Покажи повече",
  activity_edited_wrong_date: "Въвели сте грешна дата.",
  confirm_logout: "Наистина ли искате да се отпишете?",
  confirm_clockout: "Сигурни ли сте, че искате да прекратите работа за днес?",
  gps_is_active: "GPS данните се предават",
  location_tracking_is_active: "Разрешаване на GPS проследяване.",
  app_settings: "Настройки на приложението",
  clock_reminder: "Печат - Напомняне",
  mon_to_fri: "Стандарт: понеделник - петък",
  logout: "Прекъсване на връзката с акаунта",
  refresh: "Актуализация",
  prompt_language_settings: "Тук задайте езика на приложението.",
  prompt_clock_reminder: "Напомняне чрез push известие, за да съответства на ежедневната ви работа.",
  register_company: "Регистриране на фирма",
  use_code: "Използвайте код",
  our_customers: "Нашите клиенти",
  free_test_now: "Тестът вече е безплатен",
  tier_attendance: "Записвам само работните часове и почивките.",
  tier_documentation: "Искам също така да записвам работни часове за проектите, които управлявам, в часовника.",
  your_tier: "Вашият пакет",
  all_clockin_functions: "Всички функции за синхронизация",
  checklists_formulars: "Контролни списъци и функции",
  projectfile_incl_chat: "Дигитални файлове на проекта (вкл. чат)",
  photo_sketch_note: "Функция за снимки, скици и бележки",
  digital_signature: "Цифрови подписи",
  datev_connection: "Връзка DATEV",
  calendar_absences: "Управление на календара и отсъствията",
  individual_design: "Индивидуален поглед",
  attendance_time_tracking: "Запис на стационарно време чрез терминал за таблети",
  mobile_time_tracking: "Мобилно записване на времето чрез приложение за смартфон",
  browser_time_tracking: "Запис на времето в браузъра на компютъра за домашния офис",
  help_use_code: "Моля, въведете кода, който ще намерите в центъра на офиса в раздела за мобилни устройства/служители.",
  wrong_code: "Грешен код",
  wrong_code_text: "Кодът не е валиден. Моля, опитайте отново с валиден код.",
  wrong_code_text_short: "Кодът е невалиден",
  clockin_logo: "Лого на Clockin",
  invalid_qr_code: "Невалиден QR код",
  invalid_qr_code_text: "Сканираният QR код не е валиден. Моля, сканирайте валиден clockin код.",
  code_already_connected: "С този код можете да свържете устройството си. Но вие вече сте свързани.",
  wrong_credentials: "Неправилни данни за достъп",
  wrong_credentials_text: "Комбинацията от имейл и парола, която сте въвели, не може да бъде намерена. Моля, проверете въведените данни и опитайте отново.",
  new_pin: "Въвеждане на нов ПИН код",
  choose_next_action: "Изберете следващото си действие",
  name_of_software_package: "Име на софтуерния пакет",
  select_teamleader: "Кой поставя печати за отбора?",
  select_teamleader_description: "За да продължите да печатате, изберете лице, което ще поеме машината.",
  clocked_in_on_this_device: "Щампован върху тази единица",
  not_clocked_in_on_this_device: "Не е щамповано на това устройство",
  select_new_teamleader: "Кой трябва да се печати за отбора сега?",
  switch_teamleader: "Предаване на единицата",
  just_me: "Просто излязох от работа",
  select_the_new_teamleader: "Определяне на новия ръководител на екипа",
  back_to_selection: "обратно към селекцията",
  manage_team: "Управление на екипа",
  total_time_team: "Общо време на екипа",
  count_members_clocked_in: "{clockedin}/{members} Членовете на екипа са подпечатани в",
  whole_team: "Целият екип",
  teammembers_still_clockedin: "Изберете дали искате да отчитате работното време само на себе си или на всички в екипа?",
  clockout_all: "Потъпчете всички",
  select_employee: "Първо изберете потребител",
  something_went_wrong: "Нещо се е объркало, моля, опитайте отново по-късно.",
  new_pin_successfully_changed: "Успешно променен ПИН код",
  enter_pin_before_clockin_prompt: "Първо въведете ПИН кода си един по един, за да влезете в системата.",
  enter_pin_before_clockout_prompt: "Първо въведете ПИН кода си един по един, за да излезете от системата.",
  delete_activity_alert_title: "Изтриване на дейността",
  delete_activity_alert_msg: "Сигурни ли сте, че искате да изтриете дейността?",
  delete_absence_message: "Сигурни ли сте, че искате да оттеглите заявлението?",
  delete_absence_title: "Оттегляне на заявлението",
  are_you_sure: "Сигурни ли сте?",
  request_password: "Заявка за нова парола",
  password_requested: "На имейл адреса ви е изпратена връзка за нова парола.",
  no_email_retrieved: "Не сте получили имейл? Моля, проверете папката си за спам или опитайте отново.",
  name_of_customer: "Име на клиента",
  missing_permissions_homepage_text: "Нямате разрешение да променяте дейността си на тази машина. Моля, свържете се с вашия администратор, за да получите достъп.",
  no_permission_warning_my_area: "Нямате разрешение за достъп до тази област. Моля, свържете се с вашия администратор, за да получите достъп.",
  employee_clocked_in: "{name} регистрирани!",
  employee_clocked_out: "{name} излязъл от системата!",
  no_employee_to_qr_code_warning: "За този QR код не беше намерен служител.",
  no_employees_registered_heading: "Все още няма назначени служители в този отдел.",
  no_employees_registered_body: "В офисния център, в настройките на мобилното устройство, можете да назначите служители, на които да разрешите да записват времето си на това устройство.",
  no_employee_found: "За съжаление не е намерен никой с това име.",
  no_employee_assigned: "Няма назначен служител",
  you_need_help: "Имате нужда от помощ?",
  here_you_can_get_help_to_register_employees_for_device: "Тук ще намерите цялата информация за това как да назначите служители в дадено звено.",
  show_time: "Създаване на време",
  export_timesheet: "Експортиране на хронологичен лист",
  select_month: "Изберете месец",
  internet_connection_required: "За целта е необходима интернет връзка.",
  select_an_activity_to_clockin_your_team: "Изберете дейност, която да подпечатате в екипа си.",
  confirm_uploading_sqlite_for_debugging: "Сигурни ли сте, че искате да качите данните в приложението за поддръжка на Clockin?",
  no_tasks_available: "Няма налични задачи",
  click_to_add_tasks: "Кликнете, за да добавите задачи",
  scan_nfc_tag: "Моля, вдигнете картата си до четеца.",
  link_nfc_tag: "Свързване на NFC етикет",
  select_employee_for_nfc_tag: "Моля, изберете служител, който да свърже този NFC таг:",
  nfc_tag_linked_successfully: "NFC етикет успешно с {name} Свързани.",
  nfc_linking_failed: "NFC тагът не може да бъде свързан. Моля, опитайте отново.",
  nfc_not_enabled: "NFC не се поддържа от това устройство или е деактивиран.",
  nfc_initialization_failed: "За съжаление нещо се обърка. Моля, опитайте отново.",
  nfc_scan_failed: "За съжаление нещо се обърка. Моля, опитайте отново.",
  nfc_no_tag_found: "Не е открит NFC етикет.",
  nfc_tag_already_linked_to: "Този NFC етикет вече е наличен с {name} Свързани.",
  nfc_scan_active: "Активен NFC сканиране",
  nfc_linking_enabled: "NFC таговете вече могат да бъдат свързвани. Моля, задръжте NFC етикета, за да бъде свързан с NFC четеца сега.",
  nfc_all_employees_linked: "Всички служители, назначени за това устройство, вече са свързани.",
  no_employee_to_nfc_warning: "Не беше намерен служител за този NFC таг.",
  select_employee_to_link_nfc: "Към кого трябва да бъде свързан NFC тагът?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Добре дошли в Clockin",
        clocking_time: "Времена на пистите",
        push_notifications: "Не забравяй нищо"
      },
      text: {
        clocking_time: "Часовникът е вашата отправна точка за всяка дейност. Ти се грижиш за работата си, приложението прави документацията.",
        push_notifications: "Сега включи известията. Clockin ви напомня, ако забравите марка, и се уверява, че получавате всичко важно веднага."
      },
      button: {
        lets_go: "Започнете сега"
      }
    },
    my_area: {
      heading: {
        my_area: "Моята област",
        absences: "Отсъствия и заявления",
        settings: "Лични настройки"
      },
      text: {
        my_area: "Централното място, където имате незабавен преглед на работните си часове и извънредния труд. Оттук можете да управлявате работните си часове, да имате достъп до дневника си, да подавате заявки и да преглеждате работното си време.",
        absences: "Управление на молби за отпуск, болнични и други отсъствия. Винаги следете статуса на заявките си и подавайте нови бързо и лесно само с няколко кликвания.",
        settings: "Изпратете съобщения до компанията или променете личните си настройки, а ако искате да смените паролата си, можете да го направите и тук!"
      },
      button: {
        lets_go: "Започнете"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Защото времето ви е от значение",
        clock_in: "Печат в",
        switch_task: "Смяна на печата",
        clock_out: "Подпечатайте се",
        thats_it: "Това е всичко!"
      },
      text: {
        your_time_matters: "С помощта на clockin ви помагаме да се концентрирате върху най-важното. Записвайте работното си време само с едно кликване.",
        clock_in: "Само с едно кликване можете да влезете директно в час. Clockin автоматично запазва данните ви и всичко е на ваше разположение по всяко време.",
        switch_task: "Имате друг проект, почивате си или отивате на следващата среща? Просто пренасочете печата си към новата си дейност. Останалото се записва автоматично.",
        clock_out: "И с едно кликване сте изхвърлени.",
        thats_it: "Направили сте го и сте готови да записвате работното си време. Ако имате нужда от помощ, просто се свържете с нас. Всичко е лесно с clockin - включително комуникацията с нас."
      },
      button: {
        your_time_matters: "Покажи ми как се прави",
        thats_it: "Започнете сега"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Защото времето ви е от значение",
        clock_in: "Печат в",
        clock_in_team: "Екип за регистрация",
        switch_task: "Смяна на печата",
        change_teamleader: "Предаване на единицата",
        clock_out: "Подпечатайте се",
        thats_it: "Това е всичко!"
      },
      text: {
        your_time_matters: "С помощта на clockin ви помагаме да се концентрирате върху най-важното. Записвайте работното време на екипа си само с едно кликване.",
        clock_in: "Изберете лице, което се регистрира в екипа, и с едно щракване на мишката ще се регистрирате директно. clockin запазва данните автоматично и можете да следите всичко по всяко време.",
        clock_in_team: "Просто подпечатайте директно екипа си. Независимо дали всички едновременно, или само отделни членове.",
        switch_task: "Имате друг проект, почивате си или пътувате за следващата среща? Просто подпечатайте новата си дейност. Останалото ще бъде записано автоматично.",
        change_teamleader: "Приключвате работа, трябва да напуснете или вече не работите за екипа? Просто предайте устройството в приложението и всичко се връща към нормалния си ритъм.",
        clock_out: "И с едно кликване вие и екипът ви сте освободени от работа. Разбира се, можете също така да извеждате отделни членове по всяко време.",
        thats_it: "Направили сте го и сте готови да записвате работното време на екипа си. Ако имате нужда от помощ, просто се свържете с нас. Всичко е лесно с clockin - включително комуникацията с нас."
      },
      button: {
        your_time_matters: "Покажи ми как се прави",
        thats_it: "Започнете сега"
      }
    },
    my_area: {
      heading: {
        welcome: "Добре дошли във вашия район",
        my_area: "Моята област",
        create_time: "Създаване на време",
        change_time: "Правилно време",
        absences: "Отсъствия и заявления",
        settings: "Лични настройки",
        thats_it: "Това е всичко!"
      },
      text: {
        welcome: "Открийте още повече начини да управлявате работното си време ефективно и лесно. Нека да разгледаме вашата област.",
        my_area: "Централното място, където имате незабавен преглед на работните си часове и извънредния труд. Оттук можете да управлявате работните си часове, да имате достъп до дневника си, да подавате заявки и да преглеждате работното си време.",
        create_time: "Забравили сте да въведете време или искате да добавите време по-късно? Няма проблем! Добавяйте пропуснати часове, записвайте почивките и поддържайте акаунта си за работно време в актуално състояние.",
        change_time: "Искате да коригирате времето си? Няма проблем! С помощта на clockin можете лесно да коригирате и настройвате грешните времена.",
        absences: "Управление на молби за отпуск, болнични и други отсъствия. Винаги следете статуса на заявките си и подавайте нови бързо и лесно само с няколко кликвания.",
        settings: "Изпратете съобщения до компанията или променете личните си настройки, а ако искате да смените паролата си, можете да го направите и тук!",
        thats_it: "Направили сте го! Сега можете безпроблемно да управлявате времето си, да организирате отсъствията си и да се концентрирате върху важното - работата си. Успех с продуктивното ви време!"
      },
      button: {
        welcome: "Покажи ми как се прави",
        thats_it: "Започнете сега"
      }
    },
    clock: {
      clockin_now: "Заключване сега",
      clock_your_first_time_now: "& запис за първи път"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Благодарим ви, че използвате clockin!",
      question: "Доколко е вероятно да препоръчате clockin на приятели или колеги?",
      very_likely: "Много вероятно",
      very_unlikely: "Много малко вероятно",
      help_us_improve: "Как можем да подобрим работата с часовника за вас?",
      what_do_you_agree_with: "С кои твърдения сте съгласни?",
      choose_three_statements: "Изберете до три твърдения.",
      hard_to_use: "Трудно управление",
      lacking_features: "Твърде малко функции",
      does_not_help_me: "не улеснява работния ми ден",
      confusing: "объркващ",
      poorly_implemented: "Лошо изпълнени функции",
      too_buggy: "твърде склонни към грешки",
      too_slow: "дълго време за зареждане",
      what_else: "Има ли нещо друго, което бихте искали да ни кажете?",
      can_we_ask_you_a_few_questions: "Можем ли да ви зададем още няколко въпроса?",
      how_happy_are_you_with_the_introduction_of_clockin: "Доколко сте доволни от въвеждането на часовника във вашата компания?",
      how_much_do_you_enjoy_using_clockin: "Как ви харесва да използвате clockin?",
      how_much_easier_does_clockin_make_your_work: "Доколко въвеждането на часовника улеснява ежедневната ви работа?",
      how_happy_are_you_with_the_following_aspects: "Доколко сте доволни от следните точки?",
      clarity_of_the_app: "Яснота на приложението",
      simplicity_of_use: "Простота на работа",
      app_features: "Функции в приложението",
      feedback_received: "Вашата обратна връзка е получена. Благодарим ви, че отделихте време.",
      thanks_for_taking_the_time: "Благодаря ви, че отделихте време.",
      what_can_we_do_to_improve: "Можете ли да ни разкажете повече за преживяването си, за да можем следващия път да се справим още по-добре?",
      what_can_we_do_to_get_it_right: "Можете ли да ни разкажете повече за опита си, за да можем следващия път да го направим правилно?",
      comment_placeholder: "Вашето съобщение"
    }
  },
  travel_logs: {
    add: "Добавяне на подробности за пътуването",
    edit: "Редактиране на подробности за пътуването",
    saving: "Данните за пътуването се запазват...",
    saved_successfully: "Данните за пътуването са запазени успешно!",
    unable_to_save: "За съжаление, това не се получи 😢"
  },
  attach_file: "Прикачете файл",
  image_to_text: {
    info: "Уверете се, че текстът е ясно разпознаваем и може да се види изцяло на изображението.",
    attach_image: "Приложете снимка",
    processing: "Вашият текст ще бъде прочетен в.",
    processing_failed: "За съжаление, импортът не работи 😢",
    no_text_found: "Не може да бъде разпознат никакъв текст."
  },
  correction_enter_reason: "Моля, посочете причина за корекцията.",
  daily_notes: {
    add: "Напишете бележка",
    edit: "Бележка за редактиране",
    saving: "Бележката е запазена...",
    saved_successfully: "Бележката е успешно записана!",
    unable_to_save: "За съжаление, това не се получи 😢",
    no_notes_yet: "Не е създадена бележка",
    create_note: "Създаване на"
  },
  calendar_sync: {
    title: "Синхронизиране на графика",
    description: "Синхронизирайте работния си график с календар и следете старите и новите срещи.",
    url: "Адрес във формат iCal",
    url_description: "Можете да използвате този адрес за достъп до календара от други приложения.",
    note: "Забележка",
    note_description: "При някои календари показването на нови срещи може да отнеме до 24 часа.",
    sync_now: "Синхронизиране на календара",
    copied: "Копиране на URL адреса на календара."
  },
  registration: {
    skip_all: "Пропуснете всички",
    already_signed_up: "Вече имам акаунт",
    title_1: "Да започнем! Кои часове искате да запишете с clockin?",
    description_1: "Позволете ни да персонализираме часовника за вас",
    option_1_a: "Общо работно време (идване, отиване и почивка)",
    option_1_b: "Работно време на проекта",
    title_2: "Искате ли да документирате?",
    description_2: "Какви изисквания трябва да бъдат изпълнени за това?",
    option_2_a: "Снимки",
    option_2_b: "Скици",
    option_2_c: "Функция за бележки",
    option_2_d: "Контролни списъци и формуляри",
    option_2_e: "Цифрови файлове на проекта",
    title_3: "Какво още бихте искали да дигитализирате?",
    description_3: "В clockin има още много неща за откриване, може би има нещо за вас.",
    option_3_a: "Ваканция",
    option_3_b: "Болести и отсъствия",
    option_3_c: "Цифрово досие на персонала",
    option_3_d: "Анализ на компанията",
    option_3_e: "Планиране на разгръщането",
    option_3_f: "Данъчен консултант по трансфер на данни (DATEV)",
    title_4: "В коя индустрия работи вашата компания?",
    description_4: "Искаме да ви опознаем по-добре, за да можем да адаптираме часовника към вашите нужди.",
    option_4_a: "услуги",
    option_4_b: "Занаяти",
    option_4_c: "Здраве и уелнес",
    option_4_d: "Покупки, поръчки и търговия",
    option_4_e: "Хотел и кетъринг",
    option_4_f: "Автомобили, транспорт и машини",
    option_4_g: "Друга индустрия",
    title_5: "Колко са служителите на вашата компания?",
    description_5: "С броя на служителите можем да персонализираме часовника според размера на вашата компания.",
    title_6: "Супер! Вашият часовник вече е настроен",
    description_6: "Трябва ни само вашето име.",
    input_6_a: "Компания",
    input_6_b: "Първо име",
    input_6_c: "Фамилия",
    input_6_d: "Телефонен номер",
    title_7: "Готови сте за работа! Опитайте clockin 14 дни безплатно!",
    input_7_a: "Вашият имейл адрес",
    description_7: "На кой имейл адрес трябва да изпратим паролата ви?",
    input_7_b: "Така разбрах.",
    how_did_you_hear_about_clockin: "Как разбрахте за първи път за clockin?",
    recommendation_option_1: "Препоръка",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Търсене в интернет",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Платформа за сравнение",
    recommendation_option_7: "Статии в списания и онлайн",
    known_from: "Известно от",
    agb_1: "С изпращането на формуляра вие приемате ",
    agb_2: 'AGB',
    agb_3: " и ",
    agb_4: "Политика за поверителност",
    start: "Започнете теста",
    validation_failed: "Моля, попълнете правилно всички полета."
  },
  clocki: {
    listening_heading: "Слушам те.",
    listening_subtext: "Как мога да ти помогна?",
    hi_0: "Здравейте, с какво мога да ви помогна?",
    hi_1: "Как мога да ви помогна?",
    hi_2: "Здравейте, с какво мога да ви помогна?",
    hi_3: "Moin moin, какво мога да направя за вас?",
    hi_4: "Здравейте, какво мога да направя за вас?",
    hi_5: "Здравейте, с какво мога да ви помогна?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "За съжаление разпознаването на глас изглежда не работи на вашето устройство",
    microphone_permission_denied: "За съжаление нямам достъп до микрофона ви. Моля, проверете разрешенията в настройките, за да мога да ви чуя.",
    please_speak: "Вече можете да говорите с Clocki",
    create_activity: "Създаване на дейност",
    modify_activity: "Промяна на активността",
    delete_activity: "Изтриване на активност",
    create_daily_note: "Създайте ежедневна бележка",
    search_project: "Търсене на проект",
    note_copied: "Копирана бележка",
    create_absence_request: "Заявка за отсъствие",
    delete_absence: "Изтриване на отсъствието",
    confirm_deletion: "Сигурни ли сте, че вашият {activity_label} Щамповане от {date} часовникът трябва да бъде изтрит?",
    confirm_absence_deletion: "Сигурни ли сте, че вашето искане за {category} от {startDate} до {endDate} Искате ли да изтриете?",
    task_before_modification: "Преди: {task}",
    starts_at_before_modification: "Начален час преди: {startsAt}",
    ends_at_before_modification: "Крайно време преди: {endsAt}",
    something_went_wrong: "О, нещо се обърка, моля, опитайте отново по-късно.",
    was_this_helpful: "Може ли Clocki да ви помогне?",
    actions: {
      CREATE_ABSENCE: {
        title: "Потвърждаване на отсъствието"
      },
      CREATE_DAILY_NOTE: {
        title: "Създайте бележка сега",
        daily_notes_disabled: "За съжаление функцията за бележки е деактивирана. Моля, помолете вашия администратор да активира функцията в офисния център.",
        success: "Бележката е успешно записана в дневника 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Създаване на документация сега",
        created_by_clocki: "Създадено с Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Отворете \"Моите времена\" сега"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Отворете сега \"Моята област\""
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Отворете \"Промяна на паролата\" сега"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Печат \"работно време\" сега",
        PAUSE: "Печат \"Пауза\" сега",
        DRIVING_TIME: "Печат \"Време за пътуване\" сега",
        LOGOUT: "Отключване сега"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Харесва ли ви да използвате Clockin?"
  },
  translation_failed: "За съжаление преводът не проработи 😕",
  video_transcript_not_available: "Няма наличен транскрипт",
  video_upload_succeeded: "Качването на видео е завършено.",
  video_upload_failed: "Качването на видео не успя.",
  video_send_failed: "Видеото не можеше да бъде излъчено в момента. Ще опитаме пак по-късно.",
  uploading_video: "Качвам видео...",
  language_selection_header: "Избран език",
  language_selection_message: "Изберете предпочитания от вас език",
  shifts: {
    my_shifts: "Моите смени",
    free_shifts: "Свободни смени",
    next_shift: "Следващата ти смяна",
    shift_not_found: "Няма открити слоеве",
    show_shift_plan: "Вижте този график на смяната",
    no_shift_place: "Не е посочено местоположение",
    no_shifts_assigned: "В момента не си назначен на никаква смяна",
    free_shifts_unavailable: "Безплатни смени в момента не са налични",
    filter_shift_plans: "Графици за смени на филтъра",
    no_shift_plans_available: "Няма налични смени",
    filter_locations: "Места за филтриране",
    no_locations_available: "Няма свободни места",
    no_plan_selected: "Не е избран график на смяна",
    no_shifts_for_plan: "Няма намерени слоеве за този план",
    no_shifts_for_location: "Не са открити измествания за избраното място",
    unknown_shift_plan: "Неизвестен график на смени",
    unknown_location: "Неизвестно местоположение",
    loading_more_shifts: "Зареждай още слоеве..."
  },
  clockin_reminder_title: "Вече си на работа? 🔔",
  clockin_reminder: "Не забравяйте да се отпишете.",
  clockout_reminder_title: "Вече ли си в края на деня? 🔔",
  clockout_reminder: "Не забравяйте да се отпишете.",
  choose_clockin_reminder_time: "Време за напомняне за присъединяване",
  choose_clockout_reminder_time: "Напомняне за напомняне за напускане на работа",
  choose_break_reminder_time: "Продължителност на пауза",
  saved_successfully: "Успешно спасен 👍",
  clock_reminder_channel_name: "Напомняния за печати",
  clock_reminder_channel_description: "Напомняния за влизане и излизане на часовници",
  break_reminder_title: "Все още ли си почиваш? ⏰",
  break_reminder: "Забележка: Времето за почивка все още тече.",
  // Video component translations
  video_not_supported: "Устройството ти не поддържа видеото :/",
  video_loading_error: "Грешка при зареждане на видео",
  video_retry: "Презареждане"
};